import { render, staticRenderFns } from "./travelManagersConference.vue?vue&type=template&id=988c51e6&scoped=true&"
import script from "./travelManagersConference.vue?vue&type=script&lang=js&"
export * from "./travelManagersConference.vue?vue&type=script&lang=js&"
import style0 from "./travelManagersConference.vue?vue&type=style&index=0&id=988c51e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c51e6",
  null
  
)

export default component.exports